import React, {Component} from 'react';
import {connect} from 'react-redux';
import StackItem from '../molecules/stack-item';
import RemoveStackItem from '../atoms/remove-stack-item';
import {isAnyPlayerAbsentInStackItem} from '../../helpers';

class StackItems extends Component {
    render() {
        const {stacking, players} = this.props;
        const items = stacking.getItems();

        return (
            <div className="advanced-tags">
                {Object.values(items).map((item) => {
                    return isAnyPlayerAbsentInStackItem(item, players) ? null : (
                        <StackItem key={item.getId()} itemId={item.getId()}>
                            <RemoveStackItem itemId={item.getId()} />
                        </StackItem>
                    );
                })}
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        playerCombinationStacking,
        playersData: {players},
    } = state;

    return {
        stacking: playerCombinationStacking,
        players,
    };
}

export default connect(mapStatesToProps)(StackItems);
